var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.37,
  height: 19.126,
  viewBox: "0 0 17.37 19.126"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-trash-2",
  "data-name": "Icon feather-trash-2",
  transform: "translate(0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1268",
  d: "M6.927,0A2.552,2.552,0,0,0,4.391,2.54v.971H2.667a.713.713,0,0,0-.243,0H.783a.784.784,0,1,0,0,1.567h.973V16.586A2.552,2.552,0,0,0,4.3,19.126h8.776a2.553,2.553,0,0,0,2.54-2.54V5.078h.971a.784.784,0,1,0,0-1.567H14.958a.784.784,0,0,0-.255,0H12.979V2.54A2.551,2.551,0,0,0,10.44,0Zm0,1.567H10.44a.96.96,0,0,1,.971.973v.971H5.958V2.54A.961.961,0,0,1,6.927,1.567Zm-3.6,3.511H5.046a.784.784,0,0,0,.257,0h6.764a.784.784,0,0,0,.257,0h1.724V16.586a.962.962,0,0,1-.973.973H4.3a.962.962,0,0,1-.975-.973ZM6.917,7.89a.784.784,0,0,0-.771.794v5.268a.784.784,0,1,0,1.567,0V8.684a.784.784,0,0,0-.8-.794Zm3.511,0a.784.784,0,0,0-.771.794v5.268a.784.784,0,1,0,1.567,0V8.684a.784.784,0,0,0-.8-.794Z",
  transform: "translate(-0.001 0)",
  fill: "#7b7b7b"
}))));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.f9ea0147cd8f00b9b2f64ff3197c817e.svg";